import { usePulse, type NavigationStore } from '@/features/ai-changeset/hooks/useChangeNavigation';

const EMPTY = '—';

export function ProposedValue({
  before,
  after,
  start,
}: {
  before: string;
  after: string;
  start?: boolean;
  slot?: string;
}) {
  return (
    <span className={start ? 'quick-edit-value quick-edit-value--start' : 'quick-edit-value'}>
      <s className="quick-edit-old">{before || EMPTY}</s>
      <span className="ai-changed-text">{after || EMPTY}</span>
    </span>
  );
}

export function ChangePulseMarker({
  store,
  id,
  testId,
}: {
  store: NavigationStore;
  id: string;
  testId: string;
  slot?: string;
}) {
  const seq = usePulse(store, id);
  if (seq <= 0) return null;
  return <span key={seq} className="ai-changed-pulse" data-testid={testId} />;
}
